import createMetadataAPIOperations from '../../utils/api-metadata-operations';
import reducer from './reducers';
import selectors from './selectors';

const options = {
  name: 'contractStatistics',
  baseType: 'CONTRACT_STATISTICS',
  apiEndpoint: 'users/{id}/contract_statistics'
};

const operations = createMetadataAPIOperations(options);
export { operations, selectors };
export default reducer;
